import { render, staticRenderFns } from "./PaymentStatusChip.vue?vue&type=template&id=63699dc5&scoped=true&lang=pug&"
import script from "./PaymentStatusChip.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63699dc5",
  null
  
)

export default component.exports